import $ from 'jquery'

/* global refreshTomSelect -- exposed by tom-select.js */

// QrCode data_acquisition_type
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectDataAcquisitionType = $('#qr_code_data_acquisition_type')
  const selectLocationType = $('#qr_code_location_type')

  // Only proceed if we're on a page with QR code form
  if (!(selectDataAcquisitionType.length > 0 && selectLocationType.length > 0)) return

  const selectSgcSgGroup = $('#select_sgc_sg_group')
  const selectServiceGroup = $('.select_service_group')
  const selectNoticeKindGroup = $('#select_notice_kind_group')
  const selectNoticeKind = $('.select_notice_kind')
  const selectTicketKindGroup = $('#select_ticket_kind_group')
  const selectTicketKind = $('.select_ticket_kind')
  const selectTimeTrackingTypesGroup = $('#select_time_tracking_types_group')
  const selectTimeTrackingTypes = $('.select_time_tracking_types')
  const selectMaintenanceTemplateGroup = $('#select_maintenance_template_group')
  const selectMaintenanceTemplate = $('.select_maintenance_template')

  // Store original location_type options. A Turbo visit runs this handler on
  // turbo:render and again on turbo:load; re-reading the <select> the second
  // time would capture the options the first run already filtered out.
  let locationTypeOptions = selectLocationType.data('source-options-html')
  if (locationTypeOptions == null) {
    locationTypeOptions = selectLocationType.html()
    selectLocationType.data('source-options-html', locationTypeOptions)
  }
  const locationTypeOrder = ['Estate', 'Building', 'Floor', 'Room', 'Vehicle', 'Equipment']
  const locationTypeLabels = {}
  $('<select></select>').html(locationTypeOptions).find('option').each(function() {
    const optionValue = $(this).val()
    if (optionValue === '') return
    locationTypeLabels[optionValue] ||= $(this).text()
  })

  const rebuildLocationTypeOptions = (allowedValues) => {
    const nativeSelect = selectLocationType[0]
    if (nativeSelect == null) return

    nativeSelect.innerHTML = ''

    for (const optionValue of allowedValues) {
      if (locationTypeLabels[optionValue] == null) continue
      nativeSelect.add(new Option(locationTypeLabels[optionValue], optionValue))
    }
  }

  // Only Maintenance can be located at a Room, Vehicle or Equipment
  const allowedLocationTypeValues = () => {
    if (selectDataAcquisitionType.val() === 'Maintenance') return locationTypeOrder
    return ['Estate', 'Building', 'Floor']
  }

  const normalizeLocationTypeOrder = (allowedValues) => {
    const nativeSelect = selectLocationType[0]
    if (nativeSelect == null) return

    // Tom Select reorders selected <option> tags in the backing <select>.
    // Restore a stable domain-specific order for both the native element and dropdown.
    for (const optionValue of allowedValues) {
      const optionEl = nativeSelect.querySelector(`option[value='${optionValue}']`)
      if (optionEl != null) nativeSelect.append(optionEl)
    }

    if (nativeSelect.tomselect != null) {
      allowedValues.forEach((optionValue, idx) => {
        if (nativeSelect.tomselect.options[optionValue] == null) return
        nativeSelect.tomselect.options[optionValue].$order = idx + 1
      })
      nativeSelect.tomselect.lastQuery = null
      nativeSelect.tomselect.refreshOptions(false)
    }
  }

  // Filter location_type options based on data_acquisition_type
  const filterLocationTypeOptions = () => {
    const currentValue = selectLocationType.val()
    if (selectLocationType[0]?.tomselect) selectLocationType[0].tomselect.destroy()
    const allowedValues = allowedLocationTypeValues()

    rebuildLocationTypeOptions(allowedValues)

    // Restore selection if still valid
    if (selectLocationType.find(`option[value='${currentValue}']`).length > 0) {
      selectLocationType.val(currentValue)
    } else {
      selectLocationType.val('')
    }

    refreshTomSelect(selectLocationType)
    normalizeLocationTypeOrder(allowedValues)
  }

  selectLocationType.off('change.qrCodeLocationTypeOrder').on('change.qrCodeLocationTypeOrder', () => {
    normalizeLocationTypeOrder(allowedLocationTypeValues())
  })

  selectDataAcquisitionType.off('change.qrCodeDataAcquisition').on('change.qrCodeDataAcquisition', () => {
    // First disable everything
    selectSgcSgGroup.addClass('d-none')
    selectServiceGroup.attr('name', 'disabled')
    selectNoticeKindGroup.addClass('d-none')
    selectNoticeKind.attr('name', 'disabled')
    selectTicketKindGroup.addClass('d-none')
    selectTicketKind.attr('name', 'disabled')
    selectTimeTrackingTypesGroup.addClass('d-none')
    selectTimeTrackingTypes.attr('name', 'disabled')
    selectMaintenanceTemplateGroup.addClass('d-none')
    selectMaintenanceTemplate.attr('name', 'disabled')
    // … then enable conditionally
    switch (selectDataAcquisitionType.val()) {
      case 'Inspection':
        selectSgcSgGroup.removeClass('d-none')
        selectServiceGroup.attr('name', 'qr_code[service_group_id]')
        break
      case 'Notice':
        selectNoticeKindGroup.removeClass('d-none')
        selectNoticeKind.attr('name', 'qr_code[notice_kind_id]')
        break
      case 'Ticket':
        selectTicketKindGroup.removeClass('d-none')
        selectTicketKind.attr('name', 'qr_code[ticket_kind_id]')
        break
      case 'TimeTracking':
        selectTimeTrackingTypesGroup.removeClass('d-none')
        selectTimeTrackingTypes.attr('name', 'qr_code[time_tracking_type_id]')
        break
      case 'Maintenance':
        // Show maintenance template for all Maintenance types
        selectMaintenanceTemplateGroup.removeClass('d-none')
        selectMaintenanceTemplate.attr('name', 'qr_code[maintenance_template_id]')
        break
    }

    // Filter location type options based on data acquisition type
    filterLocationTypeOptions()
  })

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  if (selectDataAcquisitionType.length > 0) {
    selectDataAcquisitionType.trigger('change')
  }
})
